import { Avatar } from "@mui/material";
import { ReactNode } from "react";
import DivixLogo from "../../assets/img/divixNegro.png";
import { GetEmployeeResponseDto } from "../../services/dtos/response/UserResponseDto";

interface QRLandingBaseProps {
  employee: GetEmployeeResponseDto;
  error: { [key: string]: string };
  children: ReactNode;
}

const QRLandingBase = ({ employee, error, children }: QRLandingBaseProps) => {
  return (
    <div className="min-h-screen w-full flex flex-col">
      <header
        className="pt-8"
        style={{
          backgroundColor: employee.headerLandingColor ?? "#e0e0e0",
        }}
      >
        <img
          className="mx-auto pb-4"
          style={{
            maxWidth: '180px',
            maxHeight: '90px',
            width: 'auto',
            height: 'auto',
            objectFit: 'contain'
          }}
          src={employee.imageLogoUrl ?? DivixLogo}
          alt="Logo"
        />
        {error.load ? (
          <h3 className="w-[318px] text-wrap pb-12 mx-auto text-center font-light text-md sm:text-xl ">
            {error.load}
          </h3>
        ) : (
          <h3
            className="w-[318px] text-nowrap pb-12 mx-auto text-center font-light text-xl sm:text-2xl"
            style={{
              color: employee.textLandingColor ?? "#3a3a3a",
            }}
          >
            Califica la atención recibida:
          </h3>
        )}
      </header>
      <main className="bg-white flex flex-col justify-center items-center w-full relative">
        <div className="absolute top-0 left-1/2 transform -translate-x-1/2 -translate-y-1/2">
          <Avatar
            sx={{
              width: 80,
              height: 80,
              boxShadow: "1px 0px 18px 0 rgba(0,0,0,0.2)",
            }}
            src={
              employee.imageUrl ??
              'https://t3.ftcdn.net/jpg/05/16/27/58/360_F_516275801_f3Fsp17x6HQK0xQgDQEELoTuERO4SsWV.jpg'
            }
            alt="Avatar"
          />
        </div>
        <div className="flex items-end text-black pt-14 mb-4 font-medium shadow-sm max-w-xs text-wrap">
          <div className="py-1 px-3 flex flex-col items-center bg-[#3a3a3a] rounded-full">
            <span className="name text-sm text-center text-[#d6d6d6] md:text-xl leading-5 ">
              {employee.name}
            </span>
          </div>
        </div>
        {children}
      </main>
    </div>
  );
};

export default QRLandingBase;

